import React from 'react';
import TagInput from './TagInput';
import { Icon } from '@/shared/icons'
interface ContactIdentifiers {
  whatsapp?: string[];
  instagram?: string[];
  facebook?: string[];
  telegram?: string[];
}

interface ProviderIdentifiersDisplayProps {
  identifiers?: ContactIdentifiers;
}

/**
 * ProviderIdentifiersDisplay - Exibe identificadores de provedores em modo somente leitura
 *
 * Exibe identificadores gerenciados automaticamente por integrações no mesmo formato visual
 * dos campos de Email e Telefone (usando TagInput em modo read-only):
 * - WhatsApp: array de strings (ex: ["5547999999999@s.whatsapp.net"])
 * - Instagram: array de strings (ex: ["username", "instagram_id"])
 * - Facebook: array de strings (ex: ["username", "fb_id"])
 * - Telegram: array de strings (ex: ["@username", "telegram_id"])
 *
 * @example
 * <ProviderIdentifiersDisplay identifiers={contact.identifiers} />
 */
export const ProviderIdentifiersDisplay: React.FC<ProviderIdentifiersDisplayProps> = ({ identifiers }) => {
  if (!identifiers) return null;

  // Verificar se há pelo menos um identificador de provider
  const hasWhatsApp = identifiers.whatsapp && identifiers.whatsapp.length > 0;
  const hasInstagram = identifiers.instagram && identifiers.instagram.length > 0;
  const hasFacebook = identifiers.facebook && identifiers.facebook.length > 0;
  const hasTelegram = identifiers.telegram && identifiers.telegram.length > 0;

  const hasAnyProvider = hasWhatsApp || hasInstagram || hasFacebook || hasTelegram;

  if (!hasAnyProvider) return null;

  return (
    <div className="space-y-3">
      <div>
        <p className="text-xs text-gray-500 mb-3">
          Identificadores gerenciados automaticamente pelas integrações:
        </p>
      </div>

      {/* WhatsApp Identifiers */}
      {hasWhatsApp && (
        <TagInput
          label="WhatsApp"
          values={identifiers.whatsapp || []}
          onChange={() => {}} // Read-only
          placeholder=""
          icon={<Icon name="message-square" className="w-4 h-4 text-green-600" />}
          type="text"
          disabled={true}
        />
      )}

      {/* FaInstagram Identifiers */}
      {hasInstagram && (
        <TagInput
          label="FaInstagram"
          values={identifiers.instagram || []}
          onChange={() => {}} // Read-only
          placeholder=""
          icon={<Icon name="instagram" className="w-4 h-4 text-pink-600" />}
          type="text"
          disabled={true}
        />
      )}

      {/* FaFacebook Identifiers */}
      {hasFacebook && (
        <TagInput
          label="FaFacebook"
          values={identifiers.facebook || []}
          onChange={() => {}} // Read-only
          placeholder=""
          icon={<Icon name="facebook" className="w-4 h-4 text-blue-600" />}
          type="text"
          disabled={true}
        />
      )}

      {/* Telegram Identifiers */}
      {hasTelegram && (
        <TagInput
          label="Telegram"
          values={identifiers.telegram || []}
          onChange={() => {}} // Read-only
          placeholder=""
          icon={<Icon name="send" className="w-4 h-4 text-blue-500" />}
          type="text"
          disabled={true}
        />
      )}
    </div>
  );
};

export default ProviderIdentifiersDisplay;
